import { render, staticRenderFns } from "./UpdateCustomerProfileRole.vue?vue&type=template&id=f2325346&"
import script from "./UpdateCustomerProfileRole.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerProfileRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports